import { render, staticRenderFns } from "./Info-modal.vue?vue&type=template&id=cf3d01e2&scoped=true"
import script from "./Info-modal.vue?vue&type=script&lang=js"
export * from "./Info-modal.vue?vue&type=script&lang=js"
import style0 from "./Info-modal.vue?vue&type=style&index=0&id=cf3d01e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3d01e2",
  null
  
)

export default component.exports